<!--
Player menu component

@unstable
-->

<div class="z-container-box z-fx-col z-fx-between-center z-fx-auto" [style.background-color]="(ss.colors | async).mood">
  @if ((ss.isMobile | async) === false) {
    <button
      class="z-close-menu top"
      [style.background-color]="(ss.colors | async)?.button"
      [style.color]="(ss.colors | async)?.buttonContrast"
      (click)="close.emit()"
    >
      <mat-icon fontSet="zefplayer">close</mat-icon>
    </button>
  }

  <div class="z-content-area z-fx-col z-fx-auto z-fx-start-center z-fx-no-shrink">
    <div class="z-content-area-top z-fx z-fx-none z-fx-between-center">
      <div class="z-language-select-container z-fx z-fx-auto z-fx-end-center">
        @if (lm.showLanguageSelect()) {
          <div class="z-language-box z-fx-col z-fx-start-end z-fx-gap-4">
            <div
              class="z-dropdown-preview z-fx z-fx-center-center z-fx-gap-8"
              [style.color]="(ss.colors | async).moodContrast"
              (click.s)="onLanguagesToggle(null)"
            >
              <figure [ngClass]="flagClass(lm.currentLanguageCode)"></figure>
              <span class="z-lang-name" [style.color]="(ss.colors | async).text">{{ lm.currentLanguageName }}</span>
              <mat-icon fontSet="zefplayer" class="z-dropdown-icon" [style.color]="(ss.colors | async).text">
                arrow_down
              </mat-icon>
            </div>
            <div class="z-dropdown-holder z-fx-auto">
              @if (selectLanguage) {
                <div class="z-language-overlay">
                  <div class="z-dropdown-container">
                    <language-select
                      [locales]="lm.languages"
                      [selected]="lm.currentLanguageCode"
                      [clickOutsideActive]="selectLanguage"
                      (clickOutside)="onLanguagesToggle(false)"
                      (select)="onLanguagesToggle(false); lm.setLanguage($event)"
                    ></language-select>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (
      {
        settings: (ss.sidebar | async),
        logoUrl: (ss.logo | async)?.url || '',
        teamName: (ss.team | async)?.name || '',
      };
      as sidebar
    ) {
      <div class="z-content-area-main-content z-fx-col z-fx-auto">
        @if ((sidebar.settings?.teamLogo && sidebar.logoUrl) || (sidebar.settings?.teamName && sidebar.teamName)) {
          <div class="z-content-area-team-info z-fx-col z-fx-none z-fx-center-center z-fx-flex-center">
            @if (sidebar.logoUrl) {
              <img class="z-survey-logo" [src]="sidebar.logoUrl" alt="logo" />
            }
            @if (sidebar.settings?.teamName && sidebar.teamName) {
              <div
                class="z-team-name"
                [style.color]="(ss.colors | async).text80"
                [class.no-logo]="!(sidebar.settings?.teamLogo && sidebar.logoUrl)"
              >
                {{ sidebar.teamName | shorten: 200 : '...' }}
              </div>
            }
          </div>
        }
        @if (sidebar.settings?.sharingButtons || !sidebar.settings?.restartButton) {
          <div class="z-content-area-buttons z-fx-col z-fx-none z-fx-start-center">
            @if (!sidebar.settings?.restartButton) {
              <basic-button class="z-restart-button" [ghostCta]="true" (click)="restart.emit(); close.emit()">
                {{ 'Restart' | translateText: 'restartSurvey' }}
              </basic-button>
            }
            @if (sidebar.settings?.sharingButtons) {
              <div class="z-share-buttons-container">
                <share-buttons></share-buttons>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="z-footer z-fx-none z-fx-col z-fx-start-center">
    <div class="z-texts-paragraph" [style.color]="(ss.colors | async).text80">
      <brand-name></brand-name>
      @if (ss.branding | async) {
        <a
          class="z-terms-link"
          [href]="privacyPolicyLink((ss.branding | async).domain) | translateText: 'privacyPolicyLink'"
          [style.color]="(ss.colors | async).text80"
          target="_blank"
        >
          {{ 'Privacy Policy' | translateText: 'privacyPolicy' }}
        </a>
      }
    </div>
    @if ((ss.isMobile | async) === true) {
      <button
        class="z-close-menu bottom"
        [style.background-color]="(ss.colors | async)?.button"
        [style.color]="(ss.colors | async)?.buttonContrast"
        (click)="close.emit()"
      >
        <mat-icon fontSet="zefplayer">close</mat-icon>
      </button>
    }
  </div>
</div>
